import { render, staticRenderFns } from "./Novo-dispesas.vue?vue&type=template&id=334949da&scoped=true&"
import script from "./Novo-dispesas.vue?vue&type=script&lang=js&"
export * from "./Novo-dispesas.vue?vue&type=script&lang=js&"
import style0 from "./Novo-dispesas.vue?vue&type=style&index=0&id=334949da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334949da",
  null
  
)

export default component.exports